export let CopilotPrioritizeOnboardedCalloutTitle = "xsXGSd";
export let CopilotPrioritizeOnboardedCalloutDesc = "eZ$Nre";
export let CopilotPrioritizeOnboardedCalloutGotItButtonText = "PKlEnc";
export default {CopilotPrioritizeOnboardedCalloutTitle,CopilotPrioritizeOnboardedCalloutDesc,CopilotPrioritizeOnboardedCalloutGotItButtonText};